export default () => {
    let bannersAppRows = document.querySelectorAll('.js-bannerAppDownloadRow');

    let bannersAppRowDesktop = document.querySelector('.BannerApp__Downloads--Desktop');
    let bannersAppRowMobile = document.querySelector('.BannerApp__Downloads--Mobile');

    if(bannersAppRows){
        bannersAppRows.forEach(bannerRow => {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
                // true for mobile device 
                bannersAppRowMobile.style.display = 'flex';
                bannersAppRowDesktop.style.display = 'none';
            }else{
                // false for not mobile device 
                bannersAppRowDesktop.style.display = 'flex';
                bannersAppRowMobile.style.display = 'none';
              }
        });
    }
    
     
}